import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CheckExternalBranchApiEntity } from '../../domain/entities/CheckExternalBranchApiEntity'

export class CheckExternalBranchApiModel extends CheckExternalBranchApiEntity {
  constructor(dataDto: CheckExternalBranchApiEntity) {
    super()
    mapEntityProperties<CheckExternalBranchApiModel>(this, dataDto)
  }
}
